import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../../utility";
import Loader from "../../common/Loader";
import logo from "../../../asserts/logo.png";
import ReactToPrint from 'react-to-print';

function formateDate(dt){
    if(dt){
        let date = new Date(dt);
        let formateDate = date.toISOString()?.split('T')[0];
        return formateDate;                
    }
}

function formateTime(dt){
    if(dt){
        let date = new Date(dt);
        let formateDate = date.toISOString()?.split('T')[1];
        let time = formateDate?.split('.')[0];
        return time;
    }
}

function currentDate(){
    const date = new Date();
    const formatedDate = date.toISOString().split('T')[0];
    return formatedDate;
}

const FundRequestDetail = () => {

    const [data, setData] = useState([]);

    const [user, setUser] = useState(null);

    const [loading, setLoading] = useState(true);
    
    const { id } = useParams();
    const navigate = useNavigate();

    const componentRef = useRef();
    const componentRef2 = useRef();

    useEffect(() => {
        const token = localStorage.getItem("user_token");
        
        // console.log("token : ", token);
        axios.get(`${API_URL}/user/funds/view-request/${id}`, {headers: {'Authorization': `Bearer ${token}`}}).then((res) => {
            console.log("Fund request detail : ", res);
            setData(res?.data?.fundView);
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log("Fund request detail error : ", err);
        })
    }, [])


    useEffect(() => {
        const token = localStorage.getItem("user_token");
        // console.log("token : ", token);
        axios.get(`${API_URL}/user/profile`, {headers: {'Authorization': `Bearer ${token}`}}).then((res) => {
            console.log("View User res : ", res);
            setUser(res?.data);
        }).catch((err) => {
            console.log("View User error : ", err);
        })
    }, [])
    


    return (
        <div className="staff-detail-page">
            {loading ? (
                <Loader />
            ) : (
            <>
                <div style={{ display: 'none' }}>
                    <ComponentToPrint amount={data?.fund_amount} ref={componentRef} />
                </div>
                <div style={{ display: 'none' }}>
                    <ComponentToPrintForBill amount={data?.fund_amount} ref={componentRef2} />
                </div>
                
                <h1 className="staffRegNumber">{data?.request_id}</h1>
                <h6 className="breadCrumbs mt-4 pb-3">
                    <span className="pointer" onClick={() => navigate('/fund-requests')}>Top Up List</span>
                    <span className="greater-than"> &#62; </span>
                    <span className="viewVCardText">{data?.request_id}</span>
                </h6>

                <h3 className="staffdetail-sub-heading mt-4 mb-0">Top Up details</h3>
                <div className="d-flex pt-3">
                    <div className="div1">
                        <p className="displayBlockText">Request Balance</p>
                        <p className="displayBlockText">Date</p>
                        <p className="displayBlockText">Time</p>
                        <p className="displayBlockText">Transfer</p>
                        <p className="displayBlockText">Status</p>
                        {/* <p className="displayBlockText">Email</p>
                        <p className="displayBlockText">Phone</p>
                        <p className="displayBlockText">V-Card</p>
                        <p className="displayBlockText">V-Card status</p> */}
                    </div>
                    <div className="div2">
                        <p className="displayBlockText">{data?.fund_amount}</p>
                        <p className="displayBlockText">{formateDate(data?.created_at)}</p>
                        <p className="displayBlockText">{formateTime(data?.created_at)}</p>
                        <p className="displayBlockText">{data?.transfer_type}</p>
                        <p className="displayBlockText color-42c78f">
                            <span className={data?.status === 'Success' ? "color-42c78f" : data?.status === 'Failed'? "text-danger" : data?.status === 'Pending' ? "text-warning" : "text-secondary"}>{data?.status}</span>
                        </p>
                    </div>
                </div>

                <h3 className="staffdetail-sub-heading mt-4 mb-0">Download</h3>
                <div className="pt-3 d-flex">
                    <div className="div1">

                            <div className="d-flex flex-row align-items-center pt-2 pb-2">
                            <p className="displayBlockText">Download Quotation</p>
                            <ReactToPrint
                                    trigger={() => (
                                    <button className="pointerButton ms-4" style={{ width: '160px' }}>Quotation</button>
                                )}
                                content={() => componentRef.current}
                            />
                        </div>

                        <div className="d-flex flex-row align-items-center pt-2 pb-2">
                            <p className="displayBlockText">Download Bill</p>
                            <ReactToPrint
                                    trigger={() => (
                                    <button className="pointerButtonHollow ms-4" style={{ width: '160px' }}>Bill</button>
                                )}
                                content={() => componentRef2.current}
                            />
                        </div>
                    </div>
                </div>

                <h3 className="staffdetail-sub-heading mt-4 mb-0">User Detail</h3>
                <div className="d-flex pt-3">
                    <div className="div1">
                        <p className="displayBlockText">User account</p>
                        <p className="displayBlockText">Status</p>
                        <p className="displayBlockText">Money</p>
                        <p className="displayBlockText">VCard</p>
                        <p className="displayBlockText">Points</p>
                        <p className="displayBlockText">Name - Surname</p>
                        <p className="displayBlockText">Address</p>
                        <p className="displayBlockText">Email</p>
                        <p className="displayBlockText">Phone</p>
                        <p className="displayBlockText">Company</p>
                    </div>
                    <div className="div2">
                        <p className="displayBlockText">{user?.user?.user_account}</p>
                        {user?.user?.status === 1 ? (
                            <p className="displayBlockText color-42c78f">Enable</p>
                        ) : (
                            <p className="displayBlockText text-danger">Disable</p>
                        )}
                        <p className="displayBlockText">{Number(Number(user?.user?.money).toFixed(2)).toLocaleString()}</p>
                        <p className="displayBlockText">{user?.user?.vCard}</p>
                        <p className="displayBlockText">{Number(Number(user?.user?.points).toFixed(2)).toLocaleString()}</p>
                        <p className="displayBlockText">{user?.user?.name} {user?.user?.surename}</p>
                        <p className="displayBlockText">{user?.user?.address}</p>
                        <p className="displayBlockText">{user?.user?.email}</p>
                        <p className="displayBlockText">{user?.user?.phone_number}</p>
                        <p className="displayBlockText">{user?.user?.company}</p>
                    </div>
                </div>
                
                <h3 className="staffdetail-sub-heading mt-4 mb-0">Bill Information</h3>
                <div className="d-flex pt-3 mb-5">
                    <div className="div1">
                        <p className="displayBlockText">Company</p>
                        <p className="displayBlockText">Company Address</p>
                        <p className="displayBlockText">Phone</p>
                        <p className="displayBlockText">TAX ID</p>
                    </div>
                    <div className="div2 w-75">
                        <p className="displayBlockText">{user?.billInfo?.company_name ? user?.billInfo?.company_name : "N/A"}</p>
                        <p className="displayBlockText">{user?.billInfo?.company_address ? user?.billInfo?.company_address : "N/A"}</p>
                        <p className="displayBlockText">{user?.billInfo?.company_phone ? user?.billInfo?.company_phone : "N/A"}</p>
                        <p className="displayBlockText">{user?.billInfo?.company_tax_id ? user?.billInfo?.company_tax_id : "N/A"}</p>
                    </div>
                </div>
            </>)}
        </div>
    )
}

export default FundRequestDetail;




const ComponentToPrint = React.forwardRef(({amount}, ref) => {
    const [user, setUser] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem("user_token");
        // console.log("token : ", token);
        axios.get(`${API_URL}/user/profile`, {headers: {'Authorization': `Bearer ${token}`}}).then((res) => {
            console.log("View User res : ", res);
            setUser(res?.data);            
        }).catch((err) => {
            console.log("View User error : ", err);
        })
    }, [])

    return (
        <div className="w-100" ref={ref}>
            <div className="d-flex w-100 invoice-header px-4 py-3 pt-4">
                <div className="w-50">
                    <img src={logo} height={"125px"} alt="logo" />
                </div>
                <div className="w-50">
                    <div className="text-end">
                        {/* <h1 className="mb-1 clr-303778">PEA HOME</h1>
                        <p className="mb-1">Trigon Group (Thailand) CO., LTD.</p>
                        <p className="mb-1">(123) 456 -829</p>
                        <p className="mb-1">company@example.com</p> */}
                        <h2 className="mb-1  clr-303778">Provincial Electricity Authority</h2>
                        <p className="mb- ">200 Ngam Wong Wan Rd., Lat yao, Chatuchak Bangkok 10900</p>
                        {/* <p className="mb-1">(123) 456 -829</p> */}
                        <p className="mb-1 ">(Tax ID No.) 09940001655</p>
                    </div>
                </div>
            </div>
            <div className="w-100 text-center">
                <h1 className="clr-303778  mb-1">Quatation</h1>                            
            </div>
            <div className="d-flex w-100 px-4 py-3">
                <div className="w-50">
                    <div>                                    
                        <h2 className="mb-1 ">{user?.user?.name}</h2>
                        <p className="mb-1 ">{user?.user?.address}</p>
                        <p className="mb-1 ">{user?.user?.email}</p>
                    </div>
                </div>
                <div className="w-50">
                    <div className="text-end">
                        <p className="mb-1 mt-2 ">Date: {currentDate()}</p>
                    </div>
                </div>
            </div>
            <div className="w-100 px-4">
                <table className="pdf-table1">
                    <thead>
                        <tr>
                            <th className="">#</th>
                            <th className="">Description</th>
                            <th className="">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="bg-303778 w-60px">01</td>
                            <td>
                                <h6 className="mb-1 ">Fund Request</h6>
                                {/* <p className="mb-0">Fund request for staff</p> */}
                            </td>
                            <td className="bg-303778  w-100px">${amount}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="d-flex w-100 px-4 py-3 invoice-header">
                <div className="w-65">
                    {/* <h3 className="pt-4">Thank You</h3> */}
                </div>
                <div className="w-35">
                    <div>
                        <table className="pdf-table2">
                            <thead>
                                <tr className="bb-rgb-237">
                                    <th className="">SUBTOTAL</th>
                                    <th className="">฿{(amount - (amount * 0.07)).toFixed(2)}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="bb-303778">
                                    <th className="clr-303778">TAX 7%</th>
                                    <th className="clr-303778">฿{(amount * 0.07)?.toFixed(2)}</th>
                                </tr>
                                <tr>
                                    <th className="">GRAND TOTAL</th>
                                    <th className="">฿{(parseFloat(amount))?.toFixed(2)}</th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>            
        </div>
    )
}); 

const ComponentToPrintForBill = React.forwardRef(({amount}, ref) => {
    const [user, setUser] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem("user_token");
        // console.log("token : ", token);
        axios.get(`${API_URL}/user/profile`, {headers: {'Authorization': `Bearer ${token}`}}).then((res) => {
            console.log("View User res : ", res);
            setUser(res?.data);            
        }).catch((err) => {
            console.log("View User error : ", err);
        })
    }, [])

    return (
        <div className="w-100" ref={ref}>
            <div className="d-flex w-100 invoice-header px-4 py-3 pt-4">
                <div className="w-50">
                    <img src={logo} height={"125px"} alt="logo" />
                </div>
                <div className="w-50">
                    <div className="text-end">
                        <h2 className="mb-1 clr-303778 text-danger">Provincial Electricity Authority</h2>
                        <p className="mb-1 ">200 Ngam Wong Wan Rd., Lat yao, Chatuchak Bangkok 10900</p>
                        {/* <p className="mb-1">(123) 456 -829</p> */}
                        <p className="mb-1 ">(Tax ID No.) 09940001655</p>
                    </div>
                </div>
            </div>
            <div className="w-100 text-center ">
                <h1 className="clr-303778x mb-1 text-danger">Bill</h1>                            
            </div>
            <div className="d-flex w-100 px-4 py-3">
                <div className="w-50">
                    <div>                                    
                        <h2 className="mb-1">{user?.user?.name}</h2>
                        <p className="mb-1">{user?.user?.address}</p>
                        <p className="mb-1">{user?.user?.email}</p>
                    </div>
                </div>
                <div className="w-50">
                    <div className="text-end">
                        <p className="mb-1 mt-2 ">Date: {currentDate()}</p>
                    </div>
                </div>
            </div>
            <div className="w-100 px-4">
                <table className="pdf-table1">
                    <thead>
                        <tr>
                            <th className="">#</th>
                            <th className="">Description</th>
                            <th className="">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="bg-303778 bg-danger w-60px">01</td>
                            <td>
                                <h6 className="mb-1">Fund Request</h6>
                                {/* <p className="mb-0">Fund request for staff</p> */}
                            </td>
                            <td className="bg-303778 bg-danger w-100px">${amount}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="d-flex w-100 px-4 py-3">
                <div className="w-65">
                    {/* <h3 className="pt-4">Thank You</h3> */}
                </div>
                <div className="w-35">
                    <div>
                        <table className="pdf-table2">
                            <thead>
                                <tr className="bb-rgb-237">
                                    <th className="">SUBTOTAL</th>
                                    <th className="">฿{(amount - (amount * 0.07)).toFixed(2)}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="bb-303778">
                                    <th className="clr-303778 text-danger">TAX 7%</th>
                                    <th className="clr-303778 text-danger">฿{(amount * 0.07)?.toFixed(2)}</th>
                                </tr>
                                <tr>
                                    <th className="">GRAND TOTAL</th>
                                    <th className="">฿{(parseFloat(amount))?.toFixed(2)}</th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}); 